import React from 'react';
import { Coordinates } from '../../Models/Models';
import CropBox, { CropRect } from './CropBox';

interface PageImageCropperProps {
    imageUrl: string;
    /** Target render size of the position; only the ratio matters here. */
    ratioWidth: number;
    ratioHeight: number;
    initial?: CropRect | null;
    onChange: (coords: Coordinates) => void;
}

const PageImageCropper: React.FC<PageImageCropperProps> = ({ imageUrl, ratioWidth, ratioHeight, initial, onChange }) => (
    <CropBox
        imageUrl={imageUrl}
        aspect={ratioWidth > 0 && ratioHeight > 0 ? ratioWidth / ratioHeight : 4 / 3}
        initial={initial}
        onChange={onChange}
    />
);

export default PageImageCropper;
